import React from 'react'
import { Divider } from '@fluentui/react-components'
import { t } from '../../../../i18n/i18n'
import { UseFormReturn } from 'react-hook-form'
import { GridItem } from '../../../common/grid/GridItem'
import { ControlledAccountPicker } from '../../../common/inputs/ControlledAccountPicker'
import { ControlledTextInput } from '../../../common/inputs/TextInput'
import { ActionPlan } from '../../../../api/schemas/schema'
import { ControlledCheckbox } from '../../../common/inputs/ControlledCheckbox'
import { ControlledDatePicker } from '../../../common/inputs/DatePicker'
import { ControlledDropDown } from '../../../common/inputs/ControlledDropdown'
import { ControlledMoneyInput } from '../../../common/inputs/ControlledMoneyInput'

type ActionDecisionProps = {
   actionPlanForm: UseFormReturn<ActionPlan, any, ActionPlan>
}
export const ActionDecision = ({ actionPlanForm }: ActionDecisionProps) => {
   const {
      control,
      setValue,
      watch,
      formState: { disabled },
   } = actionPlanForm

   return (
      <>
         <GridItem size="12/12">
            <Divider appearance="brand" />
         </GridItem>
         <GridItem size="12/12">
            <ControlledCheckbox
               control={control}
               name="actionNeeded"
               checked={watch('actionNeeded') === false}
               label={t('NoActionShallBeTaken')}
               onChange={(e, data) => {
                  const actionNeeded = !watch('actionNeeded')
                  if (!actionNeeded) {
                     setValue('decidedAction', null)
                     setValue('responsible', null)
                     setValue('responsibleId', null)
                     setValue('priority', null)
                     setValue('deadline', null)
                  }
                  setValue('actionNeeded', actionNeeded, { shouldDirty: true })
               }}
            />
         </GridItem>
         {watch('actionNeeded') ? (
            <>
               <GridItem size="12/12">
                  <ControlledTextInput control={control} name={'decidedAction'} required label={t('DecisionOnAction')} multiline />
               </GridItem>
               <GridItem size="6/12">
                  <ControlledAccountPicker label={t('ResponsibleOfAction')} control={control} name={'responsible'} watch={watch} setValue={setValue} required />
               </GridItem>
               <GridItem size="6/12">
                  <ControlledMoneyInput control={control} name={'budgetedCost'} label={t('BudgetedCost')} />
               </GridItem>

               <GridItem size="6/12">
                  <ControlledDatePicker control={control} name="deadline" label={t('Deadline')} required />
               </GridItem>
               <GridItem size="6/12">
                  <ControlledDropDown
                     control={control}
                     name="priority"
                     label={t('Priority')}
                     options={[
                        { key: 1, text: t('VeryHighPriority') },
                        { key: 2, text: t('HighPriority') },
                        { key: 3, text: t('LowPriority') },
                        { key: 4, text: t('VeryLowPriority') },
                     ]}
                     disabled={disabled ?? false}
                  />
               </GridItem>
            </>
         ) : null}
         <GridItem size="12/12">
            <ControlledTextInput control={control} name={'decidedActionComment'} label={t('Comment')} multiline />
         </GridItem>
      </>
   )
}
